import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import { IoCallOutline } from 'react-icons/io5'

function About() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zipCode: '',
    message: 'Hello, Contacting you about your AllTime Home Care Services.',
    consent: true
  });

  const [status, setStatus] = useState({
    message: '',
    isError: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.message) {
      setStatus({
        message: 'Please fill in all required fields',
        isError: true
      });
      return;
    }

    try {
      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        phone: `Phone No: ${formData.phone}`,
        zip_code: `Zip Code: ${formData.zipCode}`,
        message: `Message: ${formData.message}`,
        consent: `Consent: ${formData.consent ? 'Client has consented for replies' : 'Did not Consent'}`
      };

      // Replace these with your actual EmailJS credentials
      await emailjs.send(
        'service_e24swfk',
        'template_s1ywwye',
        templateParams,
        'iO1sUlQqrICtJtYJd'
      );

      setStatus({
        message: 'Thank you for your message. We will get back to you soon!',
        isError: false
      });
      
      
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        zipCode: '',
        message: '',
        consent: true
      });

    } catch (error) {
      setStatus({
        message: 'There was an error sending your message. Please try again.',
        isError: true
      });
    }
  };

  return (
    <div>
      <img src="./images/hero2.jpeg" class="hero-image" alt="Services" />

      <div class="container-services">
              <div class="our-services">
                  <h6>AllTime Home Care</h6>
                  <h1>About Us</h1>
                  <p>
                      No matter if you’re here to find the right kind of support for independent living, or to ensure someone close to you receives the care they need to remain at home comfortably — we’re here to help. We believe that caring for people is about more than daily assistance; it’s about understanding their journey and walking alongside them every step of the way. From cooking a meal to offering round-the-clock nursing care, you can count on us to be there when it matters most.
                  </p>
                  <p>
                      At AllTime Home Care, we never compromise on quality or compassion. With years of trusted experience serving our communities, our dedicated care teams make your safety, comfort, and well-being their highest priority.
                  </p>
                  <h6 style={{marginTop: '70px'}}>Compassionate Care You Can Trust</h6>
              </div>
      
              <form onSubmit={handleSubmit} class="contact-form-container">
      
                <div class='contact-form-header'>
                  <IoCallOutline style={{fontSize: '40px', color: 'white'}} />
                  <h3>Start Care Now<br /><span>816-799-6819</span></h3>
                </div>
      
                <input
                  type="text"
                  placeholder='First Name'
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  placeholder='Last Name'
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
                <input
                  type="tel"
                  placeholder='Phone Number'
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  placeholder='Email'
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  placeholder='Zip Code'
                  name="zipCode"
                  value={formData.zipCode}
                  onChange={handleChange}
                />
      
                <div class='checkbox-container'>
                  <input
                    type='checkbox'
                    name="consent"
                    checked={formData.consent}
                    onChange={handleChange}
                  />
                  <label for='consent'>
                    By Checking this box and submitting this form  you are consenting to be contacted by SMS text messages. Message & data rates may apply. Messaging frequency may vary. You can reply stop to opt-out of further messaging. For assistance, text HELP.
                  </label>
                </div>
                {status.message && (
                  <div className={`status-message ${status.isError ? 'error' : 'success'}`}>
                    {status.message}
                  </div>
                )}
                <button type='submit'>
                  Submit
                </button>
              </form>
      </div>

      <div class='mission-section'>

        <div class='mission-subsection'>
          <h1>Our Mission</h1>
          <h3>To improve the quality of life for those we serve</h3>
          <p>Put simply, it is our mission to improve the quality of life for seniors and adults with disabilities. Of course, we recognize that everyone’s idea of “quality of life” is different, which is why it’s so important to us to make you an active part of your own care plan. We want you to be in the driver’s seat regardless of any limitations or challenges you’re facing.</p>
          <p>Most of all, we believe aging isn’t just about staying healthy, safe and independent. It’s also about living well.</p>
        </div>

        <div class='mission-subsection'>
          <img src="./images/companioncare.jpeg" alt="Our Mission" class='mission-image' />
        </div> 

      </div>

    </div>
  )
}

export default About